// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsInvoice__wrapper__580dfa4b","returnModalLink":"DetailsInvoice__returnModalLink__580dfa4b"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/DetailsInvoice.scss
// module id = 1828
// module chunks = 4 14